// extracted by mini-css-extract-plugin
export default {"pacContactBadge":"aqcHBmP9Esv8Shpl-CKrR"};